/**
 * AzleenTV Frontend App — entry point.
 */

import '../scss/main.scss';
import { AzleenTVPlayer } from './modules/player';
import { PasswordGate }   from './modules/password-gate';

function initPlayers() {
  document.querySelectorAll( '.azleentv-player' ).forEach( ( el ) => new AzleenTVPlayer( el ) );
  document.querySelectorAll( '#azleentv-gate-form' ).forEach( ( form ) => new PasswordGate( form ) );
}

if ( document.readyState === 'loading' ) {
  document.addEventListener( 'DOMContentLoaded', initPlayers );
} else {
  initPlayers();
}
